import React from 'react'

const PageNotFound = () => {
    return (
        <div style={{ margin: 'auto' }} className="">Page Not Found</div>
    )
}

export default PageNotFound